import React, { Component } from 'react';
import './OwnerShipStyle.scss';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { REDUCER_NAME, fetchInfoShareHolderTooltip } from '../../reducer';
import { formatTextFloat, formatPercent } from '../../../../helpers/Text';
import ScrollComponent from '../../../../common/ScrollComponent';
import OwnershipTooltip from './OwnershipToolip';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from './../../../../app/commonReducer';
import TimeZoneHandle from '../../../../common/timezone-handle';

const TOOLTIP_WIDTH = 450;

class TooltipShareHolder extends Component {
  renderTooltipBody = () => {
    const { tooltipData } = this.props;
    if (!tooltipData.length) {
      return (
        <div className="div-wrapper-tooltip-body">
          <div className="tooltip-body-ownship-no-data">
            <span>{I18n.t('ownerShip.noData')}</span>
          </div>
        </div>
      );
    }

    return tooltipData.map(item => (
      <div className="tooltip-body-ownship" key={item.displayCode}>
        <div
          className="children-div-body-align-left text-truncate"
          style={{ width: '40%' }}
        >
          <span style={{ fontWeight: 'bold' }}>{item.displayCode}</span>
          <span> </span>
          <span className="abc-font-small">{item.nameAndExchange}</span>
        </div>
        <div
          className="children-div-body-align-right"
          style={{
            width: '20%',
          }}
        >
          {formatTextFloat(item.quantity, 0)}
        </div>
        <div
          className="children-div-body-align-right"
          style={{
            width: '20%',
          }}
        >
          {`${formatTextFloat(formatPercent(item.percentage))} %`}
        </div>
        <div
          className="children-div-body-align-left font-weight-light"
          style={{ width: '20%' }}
        >
          <TimeZoneHandle time={item.publicDate} format={'MM/DD/YYYY'} />
        </div>
      </div>
    ));
  };

  render() {
    const {
      children,
      fetchInfoShareHolderTooltip,
      code,
      id,
      tooltipData,
      shareHolderName,
      listOrganizationByOrganCode,
    } = this.props;

    const title = I18n.t('ownerShip.titleTooltip.investmentPortfolio');
    const listTitle = I18n.t('ownerShip.listTitleTooltipShareHolder');

    return (
      <OwnershipTooltip
        tooltipData={tooltipData}
        fetchData={() =>
          fetchInfoShareHolderTooltip(code, id, listOrganizationByOrganCode)
        }
        text={children}
        tooltipWidth={TOOLTIP_WIDTH}
      >
        {tooltipData && (
          <>
            <div className="tooltip-title-ownship text-truncate">{`${title} - ${shareHolderName}`}</div>
            <div className="tooltip-header-ownship">
              <div className="align-left" style={{ width: '40%' }}>
                {listTitle.COMPANY}
              </div>
              <div className="align-right" style={{ width: '20%' }}>
                {listTitle.SHARES}
              </div>
              <div className="align-right" style={{ width: '20%' }}>
                {listTitle.PERCENTAGE}
              </div>
              <div className="align-left" style={{ width: '20%' }}>
                {listTitle.PUBLIC_DATE}
              </div>
            </div>

            <div className="div-wrapper-tooltip-body" tabIndex={0}>
              <ScrollComponent appendStyle={{ maxHeight: 100 }}>
                {this.renderTooltipBody()}
              </ScrollComponent>
            </div>
          </>
        )}
      </OwnershipTooltip>
    );
  }
}

const mapStateToProps = (state, { id, code }) => ({
  tooltipData:
    state[REDUCER_NAME].listMultiComponent[id].shareHolderTooltipInfo[code],
  listOrganizationByOrganCode:
    state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
});

const mapDispatchToProps = {
  fetchInfoShareHolderTooltip,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TooltipShareHolder);
